import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Drawer, InputWithLabel, Text } from '@reveni-io/reveni-ui'

import Header from '../Header/Header'
import * as Styles from './styles'

const UpdateSearchAddressDrawer = ({ show, searchAddress, onUpdate, onClose }) => {
  const { t } = useTranslation()
  const [street, setStreet] = useState(searchAddress.street)
  const [number, setNumber] = useState(searchAddress.number)

  useEffect(() => {
    if (show) {
      setStreet(searchAddress.street)
      setNumber(searchAddress.number)
    }
  }, [show, searchAddress.street, searchAddress.number])

  const handleChangeStreet = e => setStreet(e.target.value)

  const handleChangeNumber = e => setNumber(e.target.value)

  const handleUpdate = () => {
    onUpdate({ street, number })
  }

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false, useBlurForBackdrop: true }}>
      <Styles.Container>
        <Header title={t('Actualizar dirección del punto de recogida')} />
        <Styles.Body>
          <Text type="bodyMRegular">
            {t(
              'Usaremos esta dirección para buscar puntos de recogida cerca de ti. Esto no cambiará tu dirección de devolución.'
            )}
          </Text>
          <InputWithLabel label={t('Calle')} value={street} onChange={handleChangeStreet} fullWidth />
          <InputWithLabel label={t('Número')} value={number} onChange={handleChangeNumber} fullWidth />
        </Styles.Body>
        <Styles.ActionsContainer>
          <Button onClick={onClose} variant="outlined">
            {t('Cancelar')}
          </Button>
          <Button onClick={handleUpdate} disabled={!street}>
            {t('Actualizar')}
          </Button>
        </Styles.ActionsContainer>
      </Styles.Container>
    </Drawer>
  )
}

export default UpdateSearchAddressDrawer
